const BUTTON_CLASS_NAME = "js-rewards-filter-button"
const BUTTON_ACTIVE_CLASS_NAME = "rewards__control-button--active"
const REWARD_ITEM_CLASS_NAME = "js-reward-item"
const REWARD_ITEM_HIDDEN_CLASS_NAME = "rewards-list__item--hidden"

function changeActiveButtonClass(els, nextActiveEl) {
  els.forEach((el) => el.classList.remove(BUTTON_ACTIVE_CLASS_NAME))
  nextActiveEl.classList.add(BUTTON_ACTIVE_CLASS_NAME)
}

function toggleRewardsVisibility(rewards, type) {
  rewards.forEach((reward) => {
    if (type === "all" || reward.dataset.type === type) {
      reward.classList.remove(REWARD_ITEM_HIDDEN_CLASS_NAME)
      return
    }

    reward.classList.add(REWARD_ITEM_HIDDEN_CLASS_NAME)
  })
}

function setClickListener(rewards, els, el) {
  el.addEventListener("click", (event) => {
    event.preventDefault()

    changeActiveButtonClass(els, el)
    toggleRewardsVisibility(rewards, el.dataset.type)
  })
}

function filter(root) {
  const buttons = Array.from(root.getElementsByClassName(BUTTON_CLASS_NAME))
  const rewards = Array.from(root.getElementsByClassName(REWARD_ITEM_CLASS_NAME))

  buttons.forEach((button) => {
    setClickListener(rewards, buttons, button)
  })
}

export default filter
